import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const KEYS = {
  ArrowUp: 'up',
  ArrowDown: 'down',
  Escape: 'esc',
};

const enhanceKeysNavigationHOCGenerator = (Component, { linksDOMSelector: _linksDOMSelector }) => {
  function EnhanceKeysNavigationHOC(props) {
    const { createdRef, dropdownDisplayed, closeDropdownAndResetMatches, selectNextOption, selectPreviousOption } = props;

    useEffect(() => {
      const domRef = createdRef.current;

      const keyDownListener = (e) => {
        const key = KEYS[e.key];

        if (!key) {
          return;
        }

        e.preventDefault();

        switch (key) {
          case 'up': {
            selectPreviousOption();
            break;
          }
          case 'down': {
            selectNextOption();
            break;
          }
          case 'esc':
            closeDropdownAndResetMatches();
            break;
          default:
            break;
        }
      };

      if (domRef && dropdownDisplayed) {
        domRef.addEventListener('keydown', keyDownListener);
      }

      return () => {
        domRef.removeEventListener('keydown', keyDownListener);
      };
    }, [createdRef, dropdownDisplayed, selectNextOption, selectPreviousOption, closeDropdownAndResetMatches]);

    return <Component {...props} />;
  }

  EnhanceKeysNavigationHOC.propTypes = {
    createdRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
    dropdownDisplayed: PropTypes.bool,
    closeDropdownAndResetMatches: PropTypes.func,
    selectNextOption: PropTypes.func,
    selectPreviousOption: PropTypes.func,
  };

  return EnhanceKeysNavigationHOC;
};

const enhanceKeysNavigation =
  ({ linksDOMSelector }) =>
  (Component) =>
    enhanceKeysNavigationHOCGenerator(Component, { linksDOMSelector });

export default enhanceKeysNavigation;
